<mat-toolbar role="heading" color="primary" class="mat-elevation-z6">
    <mat-toolbar-row>
        <button mat-icon-button>
            <mat-icon aria-label="Menu Button" (click)="sidenav.toggle()">menu</mat-icon>
        </button>

        <span style="margin-left: 16px">{{ title }}</span>

        <span class="example-spacer"></span>

        <button mat-icon-button style="margin-left: 8px">
            <mat-icon aria-label="Menu Button">notifications</mat-icon>
        </button>
        <button mat-icon-button style="margin-left: 8px">
            <mat-icon aria-label="Menu Button">apps</mat-icon>
        </button>

        <button mat-icon-button style="margin-left: 8px">
            <mat-icon aria-label="Menu Button">person</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<div id="underconstructioncont">
    <marquee class="underconstruction mat-elevation-z6" scrollamount="4">☢ ☢ ☢ Under Construction ☢ ☢ ☢</marquee>
</div>

<mat-sidenav-container class="container" [hasBackdrop]="!desktop.matches">
    <mat-sidenav
        fixedInViewport
        class="menu"
        [class.noback]="desktop.matches"
        [class.noborder]="desktop.matches"
        [class.noshadow]="desktop.matches"
        #sidenav
        [opened]="desktop.matches"
        [mode]="desktop.matches ? 'side' : 'over'"
        [autoFocus]="'false'"
    >
        <div class="menu-container">
            <a mat-button class="text-left menu-item" routerLink="/map"
                ><mat-icon class="md-24 pad-right-16">map</mat-icon>Карта
            </a>

            <mat-expansion-panel expanded class="menu-item noshadow noback">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="md-24 pad-right-16" svgIcon="aquila_menu"></mat-icon>
                        Гильдия
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="menu-exp-cont">
                    <a mat-button class="text-left menu-item" routerLink="/docs/about"> О гильдии</a>

                    <a mat-button class="text-left menu-item" routerLink="/docs/rules"> Устав</a>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="menu-item noshadow noback">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="md-24 pad-right-16">broken_image</mat-icon>
                        Гайды
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="menu-exp-cont">
                    <a mat-button class="text-left menu-item" routerLink="/guides/faq">ЧАВО</a>

                    <mat-expansion-panel class="menu-item noshadow noback">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon class="md-24 pad-right-16">broken_image</mat-icon>
                                Классы
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="menu-exp-cont">
                            <a mat-button class="text-left menu-item" routerLink="/guides/archer">
                                <mat-icon class="md-24 pad-right-8" svgIcon="archer"></mat-icon>
                                Лучник
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/berserker">
                                <mat-icon class="md-24 pad-right-8" svgIcon="berserker"></mat-icon>
                                Берсерк
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/brawler">
                                <mat-icon class="md-24 pad-right-8" svgIcon="brawler"></mat-icon>
                                Крушитель
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/gunner">
                                <mat-icon class="md-24 pad-right-8" svgIcon="gunner"></mat-icon>
                                Инженер
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/lancer">
                                <mat-icon class="md-24 pad-right-8" svgIcon="lancer"></mat-icon>
                                Рыцарь
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/mystic">
                                <mat-icon class="md-24 pad-right-8" svgIcon="mystic"></mat-icon>
                                Мистик
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/ninja">
                                <mat-icon class="md-24 pad-right-8" svgIcon="ninja"></mat-icon>
                                Шиноби
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/priest">
                                <mat-icon class="md-24 pad-right-8" svgIcon="priest"></mat-icon>
                                Жрец
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/reaper">
                                <mat-icon class="md-24 pad-right-8" svgIcon="reaper"></mat-icon>
                                Жнец
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/slayer">
                                <mat-icon class="md-24 pad-right-8" svgIcon="slayer"></mat-icon>
                                Убийца
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/sorcerer">
                                <mat-icon class="md-24 pad-right-8" svgIcon="sorcerer"></mat-icon>
                                Маг
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/valkyrie">
                                <mat-icon class="md-24 pad-right-8" svgIcon="valkyrie"></mat-icon>
                                Валькирия
                            </a>

                            <a mat-button class="text-left menu-item" routerLink="/guides/warrior">
                                <mat-icon class="md-24 pad-right-8" svgIcon="warrior"></mat-icon>
                                Воин
                            </a>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="menu-item noshadow noback">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        dev
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="menu-exp-cont">
                    <a mat-button class="text-left menu-item" routerLink="/example"
                        ><mat-icon class="md-24 pad-right-16">code</mat-icon> Example</a
                    >

                    <a mat-button class="text-left menu-item" routerLink="/dev/grid">
                        <mat-icon class="md-24 pad-right-16">
                            code
                        </mat-icon>
                        Grid Template
                    </a>

                    <a
                        mat-button
                        class="text-left menu-item"
                        href="https://github.com/jfcere/ngx-markdown"
                        target="_blank"
                    >
                        <mat-icon class="md-24 pad-right-16">open_in_new</mat-icon> ngx-markdown
                    </a>

                    <a
                        mat-button
                        class="text-left menu-item"
                        href="https://material.io/tools/icons/?style=baseline"
                        target="_blank"
                    >
                        <mat-icon class="md-24" class="md-24 pad-right-16">apps</mat-icon>
                        Material Icons
                    </a>
                    <a
                        mat-button
                        class="text-left menu-item"
                        href="https://material.io/develop/web/components/typography/"
                        target="_blank"
                    >
                        <mat-icon class="md-24" class="md-24 pad-right-16">apps</mat-icon>
                        Material Typography
                    </a>

                    <a mat-button class="text-left menu-item" routerLink="/links"
                        ><mat-icon class="md-24 pad-right-16">map</mat-icon> map
                    </a>

                    <a mat-button class="text-left menu-item" routerLink="/guides"
                        ><mat-icon class="md-24 pad-right-16">settings</mat-icon> Guides
                    </a>

                    <a mat-button class="text-left menu-item" routerLink="/dashboard"
                        ><mat-icon class="md-24 pad-right-16">settings</mat-icon> Dashboard</a
                    >

                    <a mat-button class="text-left menu-item" routerLink="/heroes"
                        ><mat-icon class="md-24 pad-right-16">accessible</mat-icon> Heroes</a
                    >

                    <a mat-button class="text-left menu-item" href="https://teralore.com/" target="_blank">
                        <mat-icon class="md-24" class="md-24 pad-right-16">apps</mat-icon>
                        teralore
                    </a>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-sidenav>

    <mat-sidenav-content class="content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<!-- <button mat-fab class="to-top">
    <mat-icon class="md-48" inline aria-label="Up button">
        expand_less
    </mat-icon>
</button> -->

<app-speed-dial-fab [options]="FabOptions"></app-speed-dial-fab>
